import React, { Component } from 'react'
import { connect } from 'react-redux'
import trans from 'trans';
import store from "store";
import { AxiosResponse } from "axios";

import _debounce from "lodash/debounce";
import _find from "lodash/find"

import { deleteWatermarkGroup, publishWatermarkGroup } from "app/helpers/api";
import { createToast } from "actions";
import { WatermarkGroupType } from "products/types";

import {
    css,
    Button,
    Grid,
    GridCell,
    Icon,
    Section,
    Theme,
    Toast,
    confirm,
    Message,
} from "@bdfx/mergado-ui-kit"

import { URL } from "app/config/api-config";
import { textToast } from "app/helpers/toast_factory";
import { ReduxList } from "app/types/app-types";

import WatermarkGroupsImages, { StyledImages } from 'watermark-groups/watermark-groups-images';
import WatermarkGroupsAddProducts from 'watermark-groups/watermark-groups-add-products';
import { MAX_IMAGES_WITH_MASKS_TO_PUBLISH, MIN_IMAGES_WITH_MASKS_TO_PUBLISH } from 'watermark-groups/watermark-groups-select';

import { iconDisabledColor } from 'template-edit/components/tools-panel';

const toastIconSize = 22

interface Props {
    updateWatermarkGroups: Function
    watermarkGroups: ReduxList<WatermarkGroupType[]>
    selectedGroupId: number
    setSelectedGroupId: Function
    showAsModal: boolean
    setShowAsModal: Function
}

class WatermarksInEditor extends Component<Props> {
    constructor(props) {
        super(props);
    }

    handlePublishToTrainer = (watermarkGroupId: number, force: boolean) => {
        const { watermarkGroups } = this.props

        if (watermarkGroupId) {
            const selectedGroup: WatermarkGroupType = watermarkGroups.isLoaded ? _find(watermarkGroups.data, (watermarkGroup: WatermarkGroupType) => {
                return watermarkGroup.id === watermarkGroupId
            }) : null

            const imagesWithMasksInSelectedGroup = selectedGroup && selectedGroup.images ? selectedGroup.images.filter(i => i.user_set_objects).length : 0

            if (imagesWithMasksInSelectedGroup >= MIN_IMAGES_WITH_MASKS_TO_PUBLISH && (force || selectedGroup.published_hash !== selectedGroup.group_hash)) {
                publishWatermarkGroup(watermarkGroupId, force)
                    .then((response: AxiosResponse<any>) => {
                        store.dispatch(createToast(textToast('success', trans('sent'))))
                        this.props.updateWatermarkGroups()
                    })
                    .catch(e => console.error('error: cannot publish watermark group', e))
            } else if (imagesWithMasksInSelectedGroup < MIN_IMAGES_WITH_MASKS_TO_PUBLISH) {
                store.dispatch(createToast(textToast('error', trans('watermark_min_images'))))
                } else if (imagesWithMasksInSelectedGroup > MAX_IMAGES_WITH_MASKS_TO_PUBLISH) {
            store.dispatch(createToast(textToast('error', trans('watermark_max_images'))))
            } else if (selectedGroup.published_hash === selectedGroup.group_hash) {
                console.debug('the group is already trained, nothing to do with the group', selectedGroup.name)
            }
        }
    }

    handlePublishSelected = (selectedGroup, force) => {
        publishWatermarkGroup(selectedGroup.id, force)
            .then((response: AxiosResponse<any>) => {
                store.dispatch(createToast(textToast('success', trans('sent'))))
                this.props.updateWatermarkGroups()
            })
            .catch(e => console.error('error: cannot publish watermark group', e))
    }

    handleDeleteWatermarGroup = (g: WatermarkGroupType) => {
        return confirm({
            message: (close) => <Grid cols={'auto auto'} gap={'10px'}>
                <GridCell style={{ alignSelf: 'center' }}>{trans('confirm_remove_group')} <strong style={{ color: Theme.steelblue }}>{g.name}</strong> ({trans('count_images')}: {g.images.length})?</GridCell>
                <GridCell></GridCell>
            </Grid>,
            closeOnClickOutside: true,
            closeOnEscape: true,
            buttons: [
                <Button key="yes" onClick={() => {
                    deleteWatermarkGroup(g.id)
                        .then((response: AxiosResponse<any>) => {
                            this.props.updateWatermarkGroups()
                        })
                        .catch(e => {
                            console.error('cannot delete group', e)
                        })
                }}>{trans('yes')}</Button>,
                <Button key="no" onClick={() => false}>{trans('no')}</Button>]
        })
    }

    render(): JSX.Element {
        const { watermarkGroups, selectedGroupId, showAsModal } = this.props

        const selectedGroup = selectedGroupId ? _find(watermarkGroups.data, (watermarkGroup: WatermarkGroupType) => {
            return `${watermarkGroup.id}` === `${selectedGroupId}`
        }) : null

        const imagesWithMasksInSelectedGroup = selectedGroup && selectedGroup.images ? selectedGroup.images.filter(i => i.user_set_objects).length : 0
        const selectedImagesInGroup = selectedGroup && selectedGroup.images ? selectedGroup.images.length : 0
        const isSomeImagesWithoutMaskWarning = selectedGroup && imagesWithMasksInSelectedGroup !== selectedGroup?.images?.length
        const isDiff = selectedGroup && (selectedGroup.group_hash !== selectedGroup.published_hash || !selectedGroup.group_hash)

        return (
            <React.Fragment>
                <GridCell></GridCell>
                <GridCell>
                    <StyledDiv>
                        <Section style={{overflow: 'visible'}}>
                            {!showAsModal &&
                                <img src={`${URL.laravelBase}img/icons/beta.svg`} width={100} title={'beta version'} style={{
                                    transform: 'rotate(45deg)',
                                    position: 'absolute',
                                    right: '-30px',
                                    top: '-5px',
                                }} />
                            }
                            <StyledModalLikeDiv dataIsModal={showAsModal}>
                                <Grid cols={'auto min-content'} rows={'50px auto'} style={{ width: '100%', rowGap: '10px' }}>
                                    <GridCell className={`title ${showAsModal ? 'modal' : ''}`} style={{ position: 'relative' }}>
                                        {(imagesWithMasksInSelectedGroup < MIN_IMAGES_WITH_MASKS_TO_PUBLISH || imagesWithMasksInSelectedGroup > MAX_IMAGES_WITH_MASKS_TO_PUBLISH) &&
                                            <div>{trans('watermark_mark_images')} ({trans('marked_watermarks')} {imagesWithMasksInSelectedGroup}/{MIN_IMAGES_WITH_MASKS_TO_PUBLISH})</div>
                                        }

                                        {selectedImagesInGroup < MIN_IMAGES_WITH_MASKS_TO_PUBLISH &&
                                            <div className='error'>{trans('watermark_min_images')}</div>
                                        }

                                        {selectedImagesInGroup > MAX_IMAGES_WITH_MASKS_TO_PUBLISH &&
                                            <div className='error'>{trans('watermark_max_images')}</div>
                                        }
                                    </GridCell>

                                    <GridCell style={{ textAlign: 'right', alignSelf: 'center', marginRight: '10px' }}>
                                        {showAsModal &&
                                            <Button
                                                type={'void'}
                                                color={'nocolor'}
                                                icon={imagesWithMasksInSelectedGroup < MIN_IMAGES_WITH_MASKS_TO_PUBLISH ?
                                                    <Icon type={'close-light'} color={'#3a3a3a'} size={28} /> :
                                                    <span style={{ fontSize: 'larger', color: '#009ba9' }}>{trans('finish')}</span>
                                                }
                                                style={{ padding: '10px' }}
                                                onClick={() => {
                                                    this.props.setShowAsModal(false)
                                                    this.handlePublishToTrainer(selectedGroup?.id, false)
                                                }}
                                            />
                                        }
                                    </GridCell>
                                </Grid>

                                <StyledImages className={'inner-div'}>
                                    <Grid id={'watermark-grid-main'}>
                                        <WatermarkGroupsImages
                                            selectedWatermarkGroupId={selectedGroupId}
                                            updateWatermarkGroups={this.props.updateWatermarkGroups}
                                        />

                                        {showAsModal &&
                                            <WatermarkGroupsAddProducts
                                                watermarkGroups={watermarkGroups.data}
                                                watermarkGroup={selectedGroup}
                                                updateWatermarkGroups={this.props.updateWatermarkGroups}
                                                setSelectedGroupId={this.props.setSelectedGroupId}
                                                close={() => this.props.setShowAsModal(false)}
                                            />
                                        }

                                        {!showAsModal &&
                                            <GridCell col={'1/-1'}>
                                                <Grid cols={'max-content auto max-content'}>
                                                    <GridCell className={'left'} style={{ textAlign: 'left', alignSelf: 'center' }}>
                                                        <Button
                                                            type={'void'}
                                                            color={'nocolor'}
                                                            icon={<div style={{ display: 'flex' }}>
                                                                <img src={`${URL.laravelBase}img/icons/add-image.svg`} width={24} />
                                                                <span style={{ marginLeft: '10px', color: '#009ba9' }}>{trans('add_image')}</span>
                                                            </div>}
                                                            onClick={() => this.props.setShowAsModal(true)}
                                                        />
                                                    </GridCell>
                                                    <GridCell></GridCell>
                                                    <GridCell className={'right'} style={{ textAlign: 'right', alignSelf: 'center' }}>
                                                        {selectedGroup &&
                                                            <Button
                                                                type={'void'}
                                                                color={'nocolor'}
                                                                icon={<Icon type={'trash'} color={Theme.red} size={22} text={trans("delete")} />}
                                                                onClick={() => this.handleDeleteWatermarGroup(selectedGroup)}
                                                            />
                                                        }
                                                    </GridCell>
                                                </Grid>
                                            </GridCell>
                                        }
                                    </Grid>
                                </StyledImages>
                            </StyledModalLikeDiv>
                        </Section>


                        <StyledMessage closeable={false} icon={<Icon type={'info'} size={toastIconSize} color={Theme.steelblue} />}>
                            <Grid cols={'1fr 1fr'}>
                                {isDiff &&
                                    <GridCell style={{ alignSelf: 'center' }}>{trans('watermark_group_hash_diff')}</GridCell>
                                }
                                <GridCell style={{ alignSelf: 'center', textAlign: 'right' }}>
                                    {imagesWithMasksInSelectedGroup >= MIN_IMAGES_WITH_MASKS_TO_PUBLISH ?
                                        <Button
                                            type={'void'}
                                            size={'small'}
                                            onClick={() => this.handlePublishSelected(selectedGroup, true)}
                                            title={selectedGroup.published_at ? `last published at ${selectedGroup.published_at}` : `not published yet`}
                                            disabled={imagesWithMasksInSelectedGroup < MIN_IMAGES_WITH_MASKS_TO_PUBLISH}>{trans('publish_to_trainer')} ({imagesWithMasksInSelectedGroup})
                                        </Button> :
                                        <span style={{ color: iconDisabledColor }}>{trans('watermark_mark_images')}</span>
                                    }
                                </GridCell>
                            </Grid>
                        </StyledMessage>


                        {isSomeImagesWithoutMaskWarning &&
                            <StyledMessage closeable={true} icon={<Icon type={'info'} size={toastIconSize} color={Theme.steelblue} />}>
                                {trans('watermark_group_some_images_without_mask')}
                            </StyledMessage>
                        }

                        {imagesWithMasksInSelectedGroup < 1 &&
                            <StyledMessage closeable={true} icon={<Icon type={'info'} size={toastIconSize} color={Theme.steelblue} />}>
                                {trans('watermark_groups_info_0')}
                            </StyledMessage>
                        }
                    </StyledDiv>
                </GridCell>
            </React.Fragment>
        )
    }
}

const StyledDiv = css('div')({
    marginRight: '15px',
    marginTop: '55px',
})

const StyledMessage = css(Message)({
    textAlign: 'left',
    borderLeft: '0',
    background: '#f9f9f9',
})

const StyledModalLikeDiv = css('div')({
    margin: '10px',
    ' .title': {
        textAlign: 'center',
        alignSelf: 'center',
        fontSize: '1.4em',
        overflow: 'hidden',
    },
    ' .modal': {
        paddingTop: '40px',
    },
    ' .error': {
        fontSize: 'small',
        fontStyle: 'italic',
        color: Theme.red,
        marginTop: '5px',
    }
}, props => (props.dataIsModal ? {
    position: 'fixed',
    top: '40px',
    left: '0px',
    borderRadius: '6px',
    background: '#ffffff',
    width: 'calc(100% - 20px)',
    zIndex: 409,
    border: '1px solid #dbdbdb',
    boxShadow: '0 0 30px 1px rgba(0,0,0,.3)',
    webkitBoxShadow: '0 0 30px 1px rgba(0,0,0,.3)',
    mozBoxShadow: '0 0 30px 1px rgba(0,0,0,.3)',
    ' .inner-div': {
        width: '100%',
        height: 'calc(100vh - 130px)',
        overflowY: 'auto',
        padding: '10px',
    }
} : {

}))

function mapStateToProps(state) {
    return {
        watermarkGroups: state.watermarkGroups,
    }
}

export default connect(mapStateToProps, {
})(WatermarksInEditor)